<template>
  <v-main>
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col align-self="center" sm="8" md="6" lg="4" xl="4">
          <v-card outlined class="elevation-2 mx-auto pa-4">
            <div class="d-flex justify-center align-center">
              <img :src="logo" alt="Gigalogy Logo" class="logo" />
            </div>

            <v-card-title class="font-weight-bold">
              ログイン - Maira Voice
            </v-card-title>
            <v-card-text>
              <v-form ref="loginForm">
                <v-text-field
                  label="メールアドレス"
                  type="email"
                  v-model="loginForm.email"
                  placeholder="adam@gigalogy.com"
                  prepend-inner-icon="email"
                  outlined
                  autocomplete="off"
                  :error-messages="errors.email"
                  :rules="[required('メールアドレス'), email('メールアドレス')]"
                ></v-text-field>
                <v-text-field
                  label="パスワード"
                  v-model="loginForm.password"
                  placeholder="パスワード"
                  autocomplete="off"
                  prepend-inner-icon="lock"
                  outlined
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  :error-messages="errors.password"
                  :rules="[required('パスワード')]"
                ></v-text-field>
                <v-btn
                  color="primary"
                  type="submit"
                  large
                  block
                  :loading="loading"
                  @click="handleLoginSubmit"
                  >ログイン</v-btn
                >
              </v-form>
              <div class="font-weight-medium pt-5">
                <router-link to="/forgot-password" class="text-decoration-none">
                  パスワードをお忘れですか？
                </router-link>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapActions } from "vuex";
import {
  LOGIN,
  ADD_ALERT,
} from "@/store/_actiontypes";
import validations from "@/helpers/validations";

export default {
  name: "LoginPage",
  data() {
    return {
      logo: require("@/assets/images/logo_horizontal.png"),
      loginForm: {
        email: "",
        password: "",
      },
      errors: {
        email: "",
        password: "",
      },
      loading: false,
      showPassword: false,
      ...validations,
    };
  },
  methods: {
    ...mapActions("account", [LOGIN]),
    ...mapActions("alert", [ADD_ALERT]),
    async handleLoginSubmit(event) {
      event.preventDefault();
      this.errors = { email: "", password: "" };
      if (!this.$refs.loginForm.validate()) return;
      this.loading = true;

      const clientIP = await this.$ipCheck.getClientIP();
      const isAllowed = await this.$ipCheck.ipRangeCheck(clientIP);

      const executeLogin = async (recaptcha_token = null) => {
        this.LOGIN({
          email: this.loginForm.email,
          password: this.loginForm.password,
          recaptcha_token,
          clientIP: clientIP,
        })
          .then((response) => {
            if (response?.data?.message) {
              this.ADD_ALERT({
                message: response.data.message,
                color: "success",
              });
            }
            return this.$router.push({ name: "HomePage" });
          })
          .catch((err) => {
            console.error("Login error:", err);
            if (err?.response?.status === 401 && err?.response?.data?.message) {
              this.ADD_ALERT({
                message: err.response.data.message,
                color: "error",
              });
            } else {
              this.ADD_ALERT({
                message: "このMaira Voiceアプリケーションには招待されていません",
                color: "error",
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      };

      if (process.env.VUE_APP_CAPTCHA_ENABLED && !isAllowed) {
        this.$recaptcha
          .execute("login")
          .then((recaptcha_token) => {
            return executeLogin(recaptcha_token);
          })
          .catch((error) => {
            console.error("reCaptcha error:", error);
            this.loading = false;
          });
      } else {
        await executeLogin();
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
.logo {
  max-height: 55px;
  vertical-align: middle;
}
</style>
